import { QuestionsService } from '@APP/services/questions-service';
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators';
import { DepInjMixin, requires } from '../../mixins/dependency';
import { UserService } from '../../services/user-service';
import { commonPopupMobileStyle, commonPopupStyle } from '../../styles/common-style';
import { t } from '../../utils/locale';
import { DeviceAwareComponent } from '../components/device-aware-component';
import { DiscountIcon } from '../icons/icons';

type Deps = {
  userService: UserService;
  questionsService: QuestionsService;
};

@requires(UserService.serviceName, QuestionsService.serviceName)
@customElement('welcome-promotion-popup')
export class WelcomePromotionPopup extends DepInjMixin<Deps>(DeviceAwareComponent) {
  static get baseStyles() {
    return [
      commonPopupStyle,
      css`
        .col-1 {
          grid-column: 1;
        }

      .col-2 {
        grid-column: 2;
      }
     .title {
      font-weight: 700;
      font-size: 4rem;
      margin-bottom: 4.75rem;
    }
     .message {
        font-weight: 400;
        max-width: var(--message-max-width, 39rem);
        color: var(--c-text);
    }
      
      .message strong {
        color: var(--c-emphasize);
        font-weight: 700;
      }

      h2:last-of-type{
      margin-bottom: 2rem;
    }
    `,
    ];
  };

  static get mobileStyles() {
    return [commonPopupMobileStyle];
  }

  /**
   * The discount percent, where 1 = 100%
   */
  @property()
    discountPercent: number = 0.05;

  // connectedCallback() {
  //   super.connectedCallback();
  // }
  //
  // disconnectedCallback() {
  //   super.disconnectedCallback();
  // }

  private discountPercentString(): string {
    return `${this.discountPercent*100}%`;
  }


  renderMobileLayout() {
    return html`
      <div class="grid-container">
       <div class="col-1">
         <h1 class="title">${t('T_Welcome_Promotion_Title')}</h1>
       </div>
       <div class="col-2">
        ${DiscountIcon}
      </div>
      <div class="col-3">
        <h2 class="message">${t('T_Welcome_Promotion_Message_1')} <strong>${t('T_Welcome_Promotion_Message_2', this.discountPercentString())}</strong> ${t('T_Welcome_Promotion_Message_3')}</h2>
      </div>
     </div>
    `;
  }

  renderDesktopLayout() {
    return html`
     <div class="grid-container">
       <div class="col-1">${DiscountIcon}</div>
       <div class="col-2">
        <h1 class="title">${t('T_Welcome_Promotion_Title')}</h1>
         <h2 class="message">${t('T_Welcome_Promotion_Message_1')} <strong>${t('T_Welcome_Promotion_Message_2', this.discountPercentString())}</strong> ${t('T_Welcome_Promotion_Message_3')}</h2>
      </div>
     </div>
    `;
  }

  renderContent() {
    return this.userDevice === 'desktop' ? this.renderDesktopLayout() : this.renderMobileLayout();
  }
}
